import React from 'react'
import { useGlobalConfig } from 'context/config-context'
import styled from '@emotion/styled'
import { Form, Input, Select } from 'antd'
import { FILTER_CONDITION, FILTER_NAME, FILTER_TYPE, FILTER_VALUE } from 'views/ScanSettings/NewScan/constants'

const { Option } = Select

const StyledFilterRow = styled.div(props => ({
	display: 'grid',
	gridTemplateColumns: props.nested ? '1fr 40px' : '1fr',
	gridGap: props.nested ? 20 : 0
}))

const StyledFilterNameRow = styled.div({
	display: 'grid',
	gridTemplateColumns: '1fr'
})

const StyledFilterInputsRow = styled.div({
	display: 'grid',
	gridTemplateColumns: '150px 150px 1fr',
	gridGap: 20
})

const filterTypes = (config, isScanCompare, isDetailsView) => {
	let typesToExclude = [];
	!isScanCompare && typesToExclude.push("change");
	isDetailsView && typesToExclude.push("document");
	return config['filter_property_types'].filter((t) => !typesToExclude.includes(t)) 
}

const FilterForm = ({ form, nested=false, showNameField = false, isScanCompare = false, isDetailsView = false }) => {
	const config = useGlobalConfig()
	const { getFieldDecorator } = form;
	let types = filterTypes(config, isScanCompare, isDetailsView);
	return (
		<StyledFilterRow nested={nested}>
			<div>
				{
					showNameField && 
						<StyledFilterNameRow>
							<Form.Item label="NAME">
								{getFieldDecorator(FILTER_NAME, {
									validateTrigger: ['onChange', 'onBlur'],
									rules: [
										{
											required: true,
											whitespace: true,
											message: 'Filter Name is Required.'
										}
									]
								})(<Input placeholder="Name" />)}
							</Form.Item>
						</StyledFilterNameRow>
				}
				<StyledFilterInputsRow>
					<Form.Item label="TYPE">
						{getFieldDecorator(FILTER_TYPE, {
							validateTrigger: ['onChange', 'onBlur'],
							rules: [
								{
									required: true,
									message: 'Required'
								}
							]
						})(
							<Select placeholder="Type">
								{types.map(item => (
									<Option key={item} value={item}>
										{item}
									</Option>
								))}
							</Select>
						)}
					</Form.Item>
					<Form.Item label="CONDITION">
						{getFieldDecorator(FILTER_CONDITION, {
							validateTrigger: ['onChange', 'onBlur'],
							rules: [
								{
									required: true,
									message: 'Required'
								}
							]
						})(
							<Select placeholder="Condition">
								{config['filter_property_conditions'].map(item => (
									<Option key={item} value={item}>
										{item}
									</Option>
								))}
							</Select>
						)}
					</Form.Item>
					<Form.Item label="VALUE">
						{getFieldDecorator(FILTER_VALUE, {
							validateTrigger: ['onChange', 'onBlur'],
							rules: [
								{
									required: true,
									whitespace: true,
									message: 'Value is Required'
								}
							]
						})(<Input placeholder="VALUE" />)}
					</Form.Item>
				</StyledFilterInputsRow>
			</div>
		</StyledFilterRow>
	)
}

export default FilterForm